import React, { useEffect } from 'react';
import SubscriptionsPage from './subscriptions/SubscriptionsPage';
import './users/users.css';
import './users/brand.css';
import './subscriptions/subscriptions.css';

export default function Subscriptions() {
  useEffect(() => {
    document.body.classList.add('users-brand');
    return () => document.body.classList.remove('users-brand');
  }, []);
  return <SubscriptionsPage />;
}
